module.exports = __webpack_public_path__ + "img/webnew12.0ff43530.jpg";